<template lang="pug" src="./block-cta-modal.pug"></template>

<script>
export default {
  props: {
    props: {
      type: [Object, Array]
    },
    alt: {
      type: [Boolean],
      defaul: false
    }
  },
  data () {
    return {
      modalOpen: false,
      currItem: 0
    }
  },
  methods: {
    activate () {
      if (this.$store.state.showModal) {
        this.$store.dispatch('VIEW_SHOWMODAL', false)
      }
      this.$store.dispatch('VIEW_SHOWMODAL', true)
    },
    toggleModal () {
      this.modalOpen = !this.modalOpen
      this.modalOpen ? document.body.classList.add('open-modal') : document.body.classList.remove('open-modal')
      if (!this.modalOpen) {
        this.currItem = 0
      }
    },
    switchItem (i) {
      this.currItem = i
    }
  }
}
</script>



// WEBPACK FOOTER //
// block-cta-modal.vue?2b3ed96b